if (!customElements.get('wedding-mix')) {
  customElements.define('wedding-mix', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.inputs = [...this.querySelectorAll('[data-variant]')];
      this.message = this.querySelector('[data-error]');
      this.addEventListener('input', () => this.update());
      this.submitHandler = event => {
        const form = event.target.closest('form[data-type="add-to-cart-form"]');
        if (!form || !this.closest('product-info').contains(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.add(form);
      };
      this.clickHandler = event => {
        const button = event.target.closest('button[data-wedding-add]');
        if (!button || !this.closest('product-info').contains(button)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.add(button.form);
      };
      this.keyHandler = event => {
        if (event.key !== 'Enter' || event.target.tagName !== 'INPUT' || !this.closest('product-info').contains(event.target)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.add(this.closest('product-info').querySelector('form[data-type="add-to-cart-form"]'));
      };
      document.addEventListener('submit', this.submitHandler, true);
      document.addEventListener('click', this.clickHandler, true);
      document.addEventListener('keydown', this.keyHandler, true);
      this.update();
    }
    disconnectedCallback() {
      document.removeEventListener('submit', this.submitHandler, true);
      document.removeEventListener('click', this.clickHandler, true);
      document.removeEventListener('keydown', this.keyHandler, true);
      this.ready = false;
    }
    quantities() {
      return this.inputs.map(input => ({id: Number(input.dataset.variant), quantity: Number(input.value)}));
    }
    update() {
      const quantity = this.quantities().reduce((sum, item) => sum + item.quantity, 0);
      const rate = quantity >= 300 ? 999 : quantity >= 200 ? 1199 : quantity >= 100 ? 1399 : quantity >= 50 ? 1599 : quantity >= 20 ? 1799 : 1999;
      const money = value => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(value / 100);
      this.querySelector('[data-total]').textContent = `${quantity} ${this.config.pieces} · ${money(rate)} ${this.config.each} · ${money(quantity * rate)} ${this.config.subtotal}`;
    }
    fail(text, field) {
      this.message.textContent = text;
      this.message.hidden = false;
      (field || this.message).focus();
    }
    async add(form) {
      if (this.busy) return;
      this.message.hidden = true;
      const items = this.quantities();
      const invalid = this.inputs.find(input => !input.checkValidity());
      const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
      if (invalid || quantity < 1 || quantity > 600) return this.fail(this.config.limits, invalid);
      const scope = this.closest('product-info');
      const options = scope.querySelector('.easify-product-options');
      if (!options) return this.fail(this.config.loading);
      const option = id => options.querySelector(`[data-option-id="${id}"]`);
      const layout = option('d02449dd-54d0-4238-b19a-cbed2f47f44f')?.querySelector('button');
      const chosen = layout?.textContent.trim();
      if (!this.config.layouts.includes(chosen)) return this.fail(this.config.layoutError, layout);
      const names = option('c9a6bb2f-7a16-4ee2-8c2b-c1cf0500eee0')?.querySelector('input');
      const date = option('fa048ebd-a3bb-49d3-9e4c-3f4e0b79ba50')?.querySelector('input');
      const eventDate = option('d7920530-268e-4e17-8d5a-b5a7a0b415cb')?.querySelector('input');
      const notes = option('4d9213bc-c920-4361-b999-1c26248ceadb')?.querySelector('textarea');
      if (!names?.value.trim()) return this.fail(this.config.namesError, names);
      if (!eventDate?.value.trim()) return this.fail(this.config.dateError, eventDate);
      const properties = {'Engraving layout':chosen, 'Names or initials':names.value.trim(), 'Event date':eventDate.value.trim()};
      if (date?.value.trim()) properties['Date to engrave'] = date.value.trim();
      if (notes?.value.trim()) properties['Engraving notes'] = notes.value.trim();
      this.busy = true;
      const button = form.querySelector('button[data-wedding-add]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      let added = false;
      try {
        const root = window.Shopify.routes.root;
        const response = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error(this.config.retry);
        const cart = await response.json();
        const existing = cart.items.filter(item => Number(item.product_id) === this.config.productId);
        const combined = quantity + existing.reduce((sum, item) => sum + item.quantity, 0);
        if (combined < 10 || combined > 600) {
          this.fail(this.config.limits);
          return;
        }
        if (existing.some(item => JSON.stringify(Object.entries(item.properties || {}).filter(([key]) => !key.startsWith('_')).sort()) !== JSON.stringify(Object.entries(properties).sort()))) {
          this.fail(this.config.sameDesign);
          return;
        }
        const result = await fetch(`${root}cart/add.js`, {
          method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({items:items.filter(item => item.quantity > 0).map(item => ({...item, properties}))})
        });
        const resultData = await result.json();
        if (!result.ok) throw new Error(resultData.description || resultData.message || this.config.retry);
        added = true;
        window.location.assign(`${root}cart`);
      } catch(error) {
        this.fail(error.message || this.config.retry);
      } finally {
        if (!added) {
          this.busy = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    }
  });
}
